import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authSlice from './reducers/layout/authSlice';
import LayoutSlice from './reducers/layout/layoutSlice';
import ThemeCustomizerSlice from './reducers/layout/themeCustomizerSlice';
import ConnectionSlice from './reducers/layout/connectionSlice';

import { usersApi } from './reducers/usersSlice';

// Redux Persist imports
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage

// Combine all reducers
const rootReducer = combineReducers({
  auth: authSlice,
  layout: LayoutSlice,
  themeCustomizer: ThemeCustomizerSlice,
  connection: ConnectionSlice,

  [usersApi.reducerPath]: usersApi.reducer,
});

// Persist config
const persistConfig = {
  key: 'eta-admin',
  storage,
  whitelist: ['auth'], // persist only auth slice
};

// Wrap root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }).concat(usersApi.middleware),
});

// Export persistor for <PersistGate>
export const persistor = persistStore(store);

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
